import { render, staticRenderFns } from "./CatalogoPagina.vue?vue&type=template&id=656c2e6a&scoped=true"
import script from "./CatalogoPagina.vue?vue&type=script&lang=js"
export * from "./CatalogoPagina.vue?vue&type=script&lang=js"
import style0 from "./CatalogoPagina.vue?vue&type=style&index=0&id=656c2e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c2e6a",
  null
  
)

export default component.exports